export enum FilterType {
    STRUCTURE_PROPERTIES = 'Skladba konstrukce',
}

export const FILTER_TYPE_OPTIONS = [{ value: FilterType.STRUCTURE_PROPERTIES, label: 'Skladba konstrukce' }];
